import { Dropzone } from '@mantine/dropzone';
import { Flex, Group, rem, Text } from '@mantine/core';
import { IconPhoto, IconUpload } from '@tabler/icons-react';
import { useFileUploadController } from './controller';
import { DataFileTct } from '@dealstack/shared/lib/generated/models/DataFileTct';

interface Props {
	maxSize?: number;
	successCallback: (files: DataFileTct[]) => void;
}

export const FileUpload = ({ maxSize = 3 * 1024 ** 2, successCallback }: Props) => {
	const { onDropFiles } = useFileUploadController({ successCallback });

	return (
		<Dropzone onDrop={onDropFiles} maxSize={maxSize}>
			<Flex direction="column" align="center">
				<Group
					justify="center"
					gap="xl"
					style={{ minHeight: rem(220), pointerEvents: 'none' }}
				>
					<Dropzone.Accept>
						<IconUpload size="3.2rem" stroke={1.5} />
					</Dropzone.Accept>
					<Dropzone.Idle>
						<IconPhoto size="3.2rem" stroke={1.5} />
					</Dropzone.Idle>
					<div>
						<Text size="xl" inline>
							Drag files here or click to select files
						</Text>
					</div>
				</Group>
			</Flex>
		</Dropzone>
	);
};
